import authReducer from './authReducer'
import mapReducer from './mapReducer'
import topicReducer from './topicReducer'
import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore';
import { firebaseReducer } from 'react-redux-firebase'

const rootReducer = combineReducers({
  auth: authReducer,
  map: mapReducer,
  topic: topicReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer
});

export default rootReducer

// the key name will be the data property on the state object


// WEBPACK FOOTER //
// ./src/store/reducers/rootReducer.js